import React from 'react';
import ReactDOM from 'react-dom';

import NeedsSsoPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const createNeedsSsoScreen = ({ ssoLink }) => {
  const domId = 'needsSsoPanel';
  if (isSupportedBrowser()) {
    ReactDOM.render(
      <AuthScreenLayout>
        <NeedsSsoPanel ssoLink={ssoLink} />
      </AuthScreenLayout>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createNeedsSsoScreen = createNeedsSsoScreen;
